import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { clsx, cssVar } from "../../core/index.js";
import { useCaptions } from "./CaptionsContext.js";
import { cssPrefix } from "./utils.js";
export var Title = function Title(_ref) {
  var title = _ref.title,
      styles = _ref.styles;

  var _useCaptions = useCaptions(),
      toolbarWidth = _useCaptions.toolbarWidth;

  return React.createElement("div", {
    style: styles.captionsTitleContainer,
    className: clsx(cssPrefix("captions_container"), cssPrefix("title_container"))
  }, React.createElement("div", _objectSpread({
    style: styles.captionsTitle,
    className: cssPrefix("title")
  }, toolbarWidth ? {
    style: _defineProperty({}, cssVar("toolbar_width"), "".concat(toolbarWidth, "px"))
  } : null), title));
};